//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 预提列表申请
const withholdingList = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/withholding/list.vue')));
//预提新建、修改
const withholdingAdd = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/withholding/add.vue')));
const withholdingEdit = (r) =>
  require.ensure([], () => r(require('@/pages/financeCenter/withholding/edit.vue')));

const creditRouter = {
  path: '/withholding',
  component: index,
  children: [
    {
      path: 'withholdingList',
      name: 'withholdingList',
      component: withholdingList,
      meta: {
        keepAlive: true,
        title: '预提查询',
      },
    },
    {
      path: 'withholdingAdd',
      name: 'withholdingAdd',
      component: withholdingAdd,
      meta: {
        keepAlive: true,
        title: '预提单创建',
      },
    },
    {
      path: 'withholdingEdit',
      name: 'withholdingEdit',
      component: withholdingEdit,
      meta: {
        keepAlive: true,
        title: '预提单编辑',
      },
    },
  ],
};

export default creditRouter;
